import * as yup from 'yup'

export const schema = yup.object().shape({
  observation: yup.string().max(1000).required(),
})

export default schema
